<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";
  import { goto } from "$app/navigation";

  import { clickOutside } from "$lib/utils/clickOutside";

  export let title = "";
  export let selection = "";
  export let items: string[] = [];
  export let variant = "body2";
  export let light = false;

  export let expanded = false;

  function onClickTitle() {
    expanded = !expanded;
  }

  function handleChange(value: string) {
    selection = value;

    let url = new URL(window.location.href);
    url.searchParams.set("type", value);
    goto(url.href, { replaceState: true, noScroll: true });
    onClickTitle();
  }
</script>

<style lang="scss">
  .clothing-type-dropdown--title {
    position: relative;
    top: -1px;
  }

  .checkbox--wrapper {
    left: 0;

    position: absolute;
    background-color: $on-surface;
    display: flex;
    gap: 16px;

    padding: 1rem;
    z-index: 10;
    @include breakpoint(md) {
      max-width: 408px;
    }
  }

  .checkbox {
    display: flex;
    cursor: pointer;
    position: relative;
    align-items: center;
    border-radius: 2px;
    &--input {
      width: 24px;
      height: 24px;
    }

    &--disabled {
      pointer-events: none;
    }
  }

  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
  }

  input[type="checkbox"] {
    display: none;
  }

  .value {
    padding-left: 4px;

    @include breakpoint(md) {
      max-width: 164px;
    }
  }
</style>

<span class="clothing-type-dropdown">
  <span
    role="button"
    tabindex="0"
    on:click={() => onClickTitle()}
    on:keydown={() => onClickTitle()}
    class="clothing-type-dropdown--title"
  >
    <span class="clothing-type-dropdown--title-inner">
      <Typography
        component="span"
        variant="button1"
        theme={items.includes(selection)
          ? "surface-variant"
          : "inverse-on-surface"}
      >
        {title}
        {#if expanded}
          <Icon icon="expand_less" color="inverse-on-surface" />
        {:else}
          <Icon icon="expand_more" color="inverse-on-surface" />
        {/if}
      </Typography></span
    >
  </span>

  {#if expanded}
    <div
      class={`checkbox--wrapper`}
      use:clickOutside
      on:click-outside={onClickTitle}
    >
      {#each items as i}
        <label class={`checkbox`}>
          <input
            class="checkbox"
            aria-label={i}
            type="checkbox"
            bind:value={selection}
            on:click={() => handleChange(i)}
          />
          <div class="checkbox--input">
            {#if selection === i}
              <Icon
                icon={light ? "checkbox-filled-light" : "checkbox-filled"}
                customIcon
              />
            {:else}
              <Icon
                icon={light ? "checkbox-blank-light" : "checkbox-blank"}
                customIcon
              />
            {/if}
          </div>
          <div class="value">
            <Typography
              theme={selection === i
                ? "surface-variant"
                : light
                  ? "inverse-on-surface"
                  : "on-background"}
              component="span"
              {variant}>{i}</Typography
            >
          </div>
        </label>
      {/each}
    </div>
  {/if}
</span>
